import { render } from "./Login.vue?vue&type=template&id=4b578cfa&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=4b578cfa&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b578cfa"]])

export default __exports__